// removed by extract-text-webpack-plugin
module.exports = {"row-left":"q8_OJhOAUJTEO5AV4S7-h","hide-overflow":"_3xIaQL-mXtnCKPt5rDdYt4"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/auth/ForgotPassword.less
 ** module id = 859
 ** module chunks = 0
 **/